var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseIcon',{class:{
	'progress-star': true,
	'is-filled': _vm.filled,
	'animate': _vm.hasChanged,
},attrs:{"type":"starSmall"}})}
var staticRenderFns = []

export { render, staticRenderFns }